export default Object.freeze({
    TOTALS: 'totals',
    INSTANCE: 'instance',
    INSTANCES: 'instances',
    LIST: 'list',
});
